// extracted by mini-css-extract-plugin
module.exports = {"cxl":"2500px","qxl":"2000px","txl":"1800px","xxl":"1600px","xl":"1400px","lg":"1225px","md":"1080px","sm":"956px","xs":"765px","xxs":"525px","txs":"350px","qxs":"256","cxs":"128"};